import Play from './Play'

export default Play
// eslint-disable-next-line import/export
export * from './Play'
